import { useContext } from 'react';

import { ContextProps } from './context/props';
import { FormStepperContext } from './context';

export const useFormStepperHooks = (): ContextProps => {
  const context = useContext(FormStepperContext);

  if (!context) {
    throw new Error(
      `useFormStepperHooks must be used inside a FormStepperProvider`
    );
  }

  return context;
};

export default useFormStepperHooks;
